import React from "react";
import { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { colors } from "@mui/material";
import successImg from "../../assets/images/userprofile/successImg.png";
import { Matchmakers } from "../matchmakers";
import { Beauticians } from "../beautician";
import { axiosInstance_agent } from "../../axiosInstance-agent";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Loader from "../../Components/Loader";
import { Link, useNavigate } from "react-router-dom";
import Preloader from "../../Components/Preloader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};

const cityList = [
  "Hyderabad",
  "Visakhapatnam",
  "Vijayawada",
  "Guntur",
  "Nellore",
  "Kurnool",
  "Kakinada",
  "Rajamahendravaram",
  "Kadapa",
  "Mangalagiri-Tadepalli",
  "Tirupati",
  "Anantapuram",
  "Ongole",
  "Vizianagaram",
  "Eluru",
  "Proddatur",
  "Nandyal",
  "Adoni",
  "Madanapalle",
  "Machilipatnam",
  "Tenali",
  "Chittoor",
  "Hindupur",
  "Srikakulam",
  "Bhimavaram",
  "Tadepalligudem",
  "Guntakal",
  "Dharmavaram",
  "Gudivada",
  "Narasaraopet",
  "Kadiri",
  "Tadipatri",
  "Chilakaluripet",
  "Palakollu",
];

const services = [
  "Wedding Photography",
  "Pre-Wedding Photoshoot",
  "Birthday Photography",
  "Couple Portraits",
  "Drone Photography",
  "Photo Albums & Prints",
  "Event Photography",
  "Maternity Photoshoot",
  "Cinematic Videography",
  "Event Planning & Coordination",
  "Vendor & Venue Management",
  "Stage & Decor Setup",
  "Bridal Makeup & Hair Styling",
  "Skincare & Facial Treatments",
  "Party & Occasion Makeup",
  "Brand Endorsements & Promotions",
  "Content Creation & Reels Production",
  "Audience Engagement & Campaigns",
];

const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "application/pdf"];

const validationSchema = Yup.object({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
  profile_pic: Yup.mixed()
    .required("Profile picture is required")
    .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
      value ? SUPPORTED_FORMATS.includes(value.type) : false
    ),
  document: Yup.mixed()
    .required("Document is required")
    .test("fileFormat", "Only JPG/PNG/PDF allowed", (value) =>
      value ? SUPPORTED_FORMATS.includes(value.type) : false
    ),
  name: Yup.string().required("Service name is required"),
  min_price: Yup.number().required("Min Price is required"),
  max_price: Yup.number().required("Max Price is required"),
  about: Yup.string().required("About is required"),
  service_provided: Yup.array().min(
    1,
    "Please select at least one Services Provided"
  ),
  locations: Yup.array().min(1, "Please select at least one city"),
  user_image: Yup.array()
    .min(1, "Please upload at least one image")
    .max(4, "You can upload a maximum of 4 images")
    .test("fileFormat", "Only JPG, PNG or PDF files are allowed", (files) =>
      files
        ? files.every((file) => file && SUPPORTED_FORMATS.includes(file.type))
        : false
    ),
});

export function BeauticianAdd() {
  const [loader, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownServices, setShowDropdownServices] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [imageNames, setImageNames] = useState("Browse");
  const dropdownRef = useRef(null);
  const dropdownServicesRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownServicesRef.current &&
        !dropdownServicesRef.current.contains(event.target)
      ) {
        setShowDropdownServices(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCityChange = (city) => {
    const selected = formik.values.locations;
    if (selected.includes(city)) {
      formik.setFieldValue(
        "locations",
        selected.filter((c) => c !== city)
      );
    } else {
      formik.setFieldValue("locations", [...selected, city]);
    }
  };

  const handleServiceProvidedChange = (service) => {
    const selected = formik.values.service_provided;
    if (selected.includes(service)) {
      formik.setFieldValue(
        "service_provided",
        selected.filter((c) => c !== service)
      );
    } else {
      formik.setFieldValue("service_provided", [...selected, service]);
    }
  };

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      agency_name: "",
      profile_pic: null,
      document: null,
      category: "Beautician",
      name: "",
      min_price: "",
      max_price: "",
      about: "",
      service_provided: [],
      locations: [],
      user_image: [],
    },
    validationSchema,
    onSubmit: async (values, { resetForm, setErrors }) => {
      setLoading(true);

      try {
        // 1. Prepare form data for Agent/register
        const agentData = new FormData();
        agentData.append("first_name", values.first_name);
        agentData.append("last_name", values.last_name);
        agentData.append("email", values.email);
        agentData.append("mobile", values.mobile);
        agentData.append("agency_name", values.agency_name);
        agentData.append("profile_pic", values.profile_pic);
        agentData.append("document", values.document);
        agentData.append("category", "Beautician");

        console.log("👤 Register Agent Data:");
        for (let pair of agentData.entries()) {
          console.log(pair[0], pair[1]);
        }

        // 2. Call /Agent/register
        const agentRes = await axiosInstance_agent.post(
          "/Agent/register",
          agentData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        const userId = agentRes.data?.data?.id;
        if (!userId) {
          throw new Error("User ID not returned from Agent/register");
        }

        // 3. Prepare data for /Beautician/create
        const BeauticianData = new FormData();
        BeauticianData.append("name", values.name);
        BeauticianData.append("min_price", values.min_price);
        BeauticianData.append("max_price", values.max_price);
        BeauticianData.append("about", values.about);
        BeauticianData.append("user_id", userId);
        BeauticianData.append("category", "Beautician");

        // Send locations array as JSON string
        BeauticianData.append("locations", JSON.stringify(values.locations));

        // Append multiple user images
        if (Array.isArray(values.user_image) && values.user_image.length > 0) {
          values.user_image.forEach((file) => {
            BeauticianData.append("user_image", file);
          });
        }

        BeauticianData.append(
          "service_provided",
          JSON.stringify(values.service_provided)
        );

        console.log("Beautician Data:");
        for (let pair of BeauticianData.entries()) {
          console.log(pair[0], pair[1]);
        }

        // 4. Call /Beautician/create
        const BeauticianRes = await axiosInstance_agent.post(
          "/beautician/create",
          BeauticianData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        console.log("✅ Beautician created:", BeauticianRes.data);
        toast.success("Beautician successfully created!");
        resetForm();
        handleOpen();
        setTimeout(() => {
          handleClose();
          navigate("/beauticians");
        }, 2000);
      } catch (error) {
        console.error("❌ Submission error:", error);

        const responseErrors = error?.response?.data;

        // Handle field-specific errors
        if (responseErrors && typeof responseErrors === "object") {
          const fieldErrors = {};

          Object.entries(responseErrors).forEach(([key, value]) => {
            fieldErrors[key] = Array.isArray(value) ? value[0] : value;
            // Show toast message too
            toast.error(`${key}: ${fieldErrors[key]}`);
          });

          // Set formik field errors
          setErrors(fieldErrors);
        } else {
          // Generic fallback error
          const message =
            error?.response?.data?.message ||
            "Submission failed. Please try again.";
          toast.error(message);
        }
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      {loader && <Preloader />}
      <div>
        <div className="matchEdit-subcontainer">
          <Link to="/beauticians">
            <div className="bi bi-arrow-left"></div>
          </Link>

          <div className="matchAdd-menu">
            <div>Basic Information</div>
          </div>
        </div>

        {/* content */}
        <div className="MatchMainContainer">
          <form onSubmit={formik.handleSubmit}>
            <div>
              {/* row1 */}
              <div className="MatchSubcontainer">
                <div>
                  <div className="match-lableName">
                    First Name <span className="text-danger">*</span>
                  </div>
                  <div className="matchTextbox">
                    <input
                      type="text"
                      name="first_name"
                      placeholder="Enter First Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.first_name}
                    />
                    {formik.touched.first_name && formik.errors.first_name && (
                      <div className="error">{formik.errors.first_name}</div>
                    )}
                  </div>
                </div>

                <div>
                  <div className="match-lableName">
                    Last Name <span className="text-danger">*</span>
                  </div>
                  <div className="matchTextbox">
                    <input
                      type="text"
                      name="last_name"
                      placeholder="Enter Last Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.last_name}
                    />
                    {formik.touched.last_name && formik.errors.last_name && (
                      <div className="error">{formik.errors.last_name}</div>
                    )}
                  </div>
                </div>
              </div>

              {/* row2 */}
              <div className="MatchSubcontainer">
                <div>
                  <div className="match-lableName">
                    Profile Image <span className="text-danger">*</span>
                  </div>
                  <div className="matchTextbox">
                    <label
                      htmlFor="profile_pic_input"
                      className="custom-file-label"
                    >
                      {formik.values.profile_pic?.name || "Browse"}
                    </label>
                    <input
                      type="file"
                      id="profile_pic_input"
                      className="custom-file-input"
                      accept="image/*"
                      name="profile_pic"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "profile_pic",
                          event.currentTarget.files[0]
                        );
                      }}
                    />
                    {formik.touched.profile_pic &&
                      formik.errors.profile_pic && (
                        <div className="error">{formik.errors.profile_pic}</div>
                      )}
                  </div>
                </div>

                <div>
                  <div className="match-lableName">
                    Email <span className="text-danger">*</span>
                  </div>
                  <div className="matchTextbox">
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter Email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="error">{formik.errors.email}</div>
                    )}
                  </div>
                </div>
              </div>
              {/* row3 */}
              <div className="MatchSubcontainer">
                <div>
                  <div className="match-lableName">
                    Mobile Number <span className="text-danger">*</span>
                  </div>
                  <div className="matchTextbox">
                    <input
                      type="number"
                      name="mobile"
                      onChange={formik.handleChange}
                      value={formik.values.mobile}
                      maxLength={10}
                    />
                    {formik.touched.mobile && formik.errors.mobile && (
                      <div className="error">{formik.errors.mobile}</div>
                    )}
                  </div>
                </div>

                <div>
                  <div className="match-lableName">Agency Name</div>
                  <div className="matchTextbox">
                    <input
                      type="text"
                      name="agency_name"
                      onChange={formik.handleChange}
                      value={formik.values.agency_name}
                    />
                  </div>
                </div>
              </div>
              {/* row4 */}
              <div className="MatchSubcontainer">
                <div>
                  <div className="match-lableName">
                    Min Price <span className="text-danger">*</span>
                  </div>
                  <div className="matchTextbox">
                    <input
                      type="number"
                      name="min_price"
                      onChange={formik.handleChange}
                      value={formik.values.min_price}
                      min="0" // doesn't allow nagative values
                    />
                    {formik.touched.min_price && formik.errors.min_price && (
                      <div className="error">{formik.errors.min_price}</div>
                    )}
                  </div>
                </div>
                <div>
                  <div className="match-lableName">
                    Max Price <span className="text-danger">*</span>
                  </div>
                  <div className="matchTextbox">
                    <input
                      type="number"
                      name="max_price"
                      onChange={formik.handleChange}
                      value={formik.values.max_price}
                      min="0" // doesn't allow nagative values
                    />
                    {formik.touched.max_price && formik.errors.max_price && (
                      <div className="error">{formik.errors.max_price}</div>
                    )}
                  </div>
                </div>
              </div>
              {/* row5 */}
              <div className="MatchSubcontainer">
                <div>
                  <div
                    className="city-dropdown-wrapper"
                    ref={dropdownServicesRef}
                  >
                    <label className="match-lableName">
                      Select Services <span className="text-danger">*</span>
                    </label>
                    <div
                      className="city-dropdown-btn"
                      onClick={() => setShowDropdownServices((prev) => !prev)}
                    >
                      {formik.values.service_provided.length > 0
                        ? formik.values.service_provided.join(", ")
                        : "Select services"}
                    </div>

                    {showDropdownServices && (
                      <div className="city-dropdown-list">
                        {services.map((services) => (
                          <label key={services} className="city-dropdown-item">
                            <input
                              type="checkbox"
                              value={services}
                              checked={formik.values.service_provided.includes(
                                services
                              )}
                              onChange={() =>
                                handleServiceProvidedChange(services)
                              }
                            />
                            {services}
                          </label>
                        ))}
                      </div>
                    )}

                    {formik.touched.service_provided && formik.errors.service_provided && (
                      <div className="city-error">
                        {formik.errors.service_provided}
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <div className="match-lableName">
                    Service Name <span className="text-danger">*</span>
                  </div>
                  <div className="matchTextbox">
                    <input
                      type="text"
                      name="name"
                      placeholder="Service Name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <div className="error">{formik.errors.name}</div>
                    )}
                  </div>
                </div>
              </div>
              {/* row6 */}
              <div className="MatchSubcontainer">
                <div>
                  <div className="match-lableName">
                    Event Images <span className="text-danger">*</span>
                  </div>
                  <div className="matchTextbox">
                    <label htmlFor="user_image" className="custom-file-label">
                      {formik.values.user_image?.length
                        ? formik.values.user_image
                            .map((file) => file.name)
                            .join(", ")
                        : "Browse"}
                    </label>
                    <input
                      type="file"
                      id="user_image"
                      className="custom-file-input"
                      accept="image/*"
                      name="user_image"
                      multiple
                      onChange={(event) => {
                        const files = Array.from(event.currentTarget.files);
                        formik.setFieldValue("user_image", files);
                      }}
                    />
                    {formik.touched.user_image && formik.errors.user_image && (
                      <div className="error">{formik.errors.user_image}</div>
                    )}
                  </div>
                </div>

                <div>
                  <div className="city-dropdown-wrapper" ref={dropdownRef}>
                    <label className="match-lableName">
                      Select Cities <span className="text-danger">*</span>
                    </label>
                    <div
                      className="city-dropdown-btn"
                      onClick={() => setShowDropdown((prev) => !prev)}
                    >
                      {formik.values.locations.length > 0
                        ? formik.values.locations.join(", ")
                        : "Select Cities"}
                    </div>

                    {showDropdown && (
                      <div className="city-dropdown-list">
                        {cityList.map((city) => (
                          <label key={city} className="city-dropdown-item">
                            <input
                              type="checkbox"
                              value={city}
                              checked={formik.values.locations.includes(city)}
                              onChange={() => handleCityChange(city)}
                            />
                            {city}
                          </label>
                        ))}
                      </div>
                    )}

                    {formik.touched.locations && formik.errors.locations && (
                      <div className="city-error">
                        {formik.errors.locations}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* row7 */}
              <div className="MatchSubcontainer">
                <div>
                  <div className="match-lableName">
                    Aadharcard or Pancard <span className="text-danger">*</span>
                  </div>
                  <div className="matchTextbox">
                    <label
                      htmlFor="document_input"
                      className="custom-file-label"
                    >
                      {formik.values.document?.name || "Browse"}
                    </label>
                    <input
                      type="file"
                      id="document_input"
                      className="custom-file-input"
                      accept="image/*"
                      name="document"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "document",
                          event.currentTarget.files[0]
                        );
                      }}
                    />
                    {formik.touched.document && formik.errors.document && (
                      <div className="error">{formik.errors.document}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="MatchSubcontainer">
                <div>
                  <div className="match-lableName">
                    About <span className="text-danger">*</span>
                  </div>
                  <div className="matchTextbox">
                    <textarea
                      name="about"
                      placeholder="Type Here"
                      rows={4}
                      onChange={formik.handleChange}
                      value={formik.values.about}
                    ></textarea>
                    {formik.touched.about && formik.errors.about && (
                      <div className="error">{formik.errors.about}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="btnMakerAddSave m-2 mb-2">
                <Button type="submit" disabled={loader}>
                  {loader ? "Saving..." : "Save"}
                </Button>
              </div>
            </div>
          </form>

          <div>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open}
              onClose={handleClose} //close modal on background click
              closeAfterTransition
            >
              <Fade in={open}>
                <Box sx={style} className="modal-box">
                  <img srcSet={successImg} />
                  <Typography
                    id="transition-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Thank You
                  </Typography>
                  <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                    The profile has been successfully updated
                  </Typography>
                </Box>
              </Fade>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
}
